module.exports = __webpack_public_path__ + "img/description_black_24dp.6243a69d.svg";